import { SciSettings } from '@/api/interface/self-check-in'
import Colors from '@/styles/Colors.module.scss'

export interface SciErrorDialogContentProps {
  settings: SciSettings
  errorTitle?: string
  errorMsg?: string
  handleCloseDialog: () => void
}
export const SciErrorDialogContent = ({ 
  settings, 
  errorTitle = "Something went wrong", 
  errorMsg = "Something went wrong while checking you in. Please try again.", 
  handleCloseDialog 
}) => {
  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 700 }}>
        {errorTitle}
      </h2>
      <p style={{ margin: '20px 0' }}>
        {errorMsg}
      </p>

      <button
        className="btn"
        style={{
          width: '100%',
          height: 60,
          fontSize: '1.25rem',
          fontWeight: 'bold',
          marginTop: '0.875rem',
          marginBottom: '1rem',
          borderRadius: '99px',
          backgroundColor:
            settings?.btnBackgroundColor || Colors['theme-green'],
          color: settings?.btnTextColor || Colors['theme-white'],
        }}
        onClick={() => {
          handleCloseDialog()
        }}
      >
        Try Again
      </button>
    </div>
  )
}

export default SciErrorDialogContent